import { findInViewHierarchy } from '../../shared/registry';

export function findPlugin(name, type, instance) {
	return findInViewHierarchy(type, instance, name);
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/static/findPlugin.js.map
